<template>
  <div class="min-h-screen w-full bg-[#f6f5f1]">

    <!-- Header -->
    <header class="bg-[#99b305] text-black sticky top-0 z-10">
      <section class="w-full py-2 flex justify-between items-center px-4">
        <img
          src="@/assets/xx_Images/xx_Images/wordmark/wordmark_hell_scaled.png"
          alt="Logo"
          class="w-3/6 max-w-[180px] sm:max-w-[200px] mr-9"
        />
        <div class="flex justify-center items-center space-x-2 sm:space-x-4">
          <!-- Button -->
          <button class="nav-button-spielbeschreibung hover-button">
            <img 
              src="@/assets/xx_Images/xx_Images/Buttons/button jzt spielen.png" 
              alt="Jetzt spielen" 
              class="lg:max-h-[46px] md:max-h-[45px] sm:max-h-[35px] max-h-[35px] px-2 hover:opacity-80 hover:scale-110 transform transition-transform duration-200 ease-in-out" 
            />
          </button>
        </div>
      </section>
    </header>
      
    <!-- Main Content -->
    <main class="lg:max-w-6xl md:max-w-6xl sm:max-w-6xl mx-auto lg:mt-[80px] md:mt-[70px] sm:mt-[60px] mt-[40px] px-10 sm:px-1">
      <!-- Title -->
      <h1 class="font-pixelsplitter lg:text-[50px] md:text-[38px] sm:text-[20px] text-[20px] text-center">Impressum</h1>

      <!-- Content -->
      <div class="content-datenschutz lg:mt-10 md:mt-8 sm:mt-6 mt-6 text-sm sm:text-base leading-relaxed lg:mx-[250px] md:mx-[200px] sm:mx-[50px] mx-[50px]">
        <p class="mb-6">
          Informationspflicht laut Offenlegungspflicht laut §25 Mediengesetz
        </p>
        
        <!-- Website Team -->
        <h2 class="font-bold mt-6">Websitebetreiber-Team:</h2>
        <p>Alexander Nems</p>
        <p>Thuy Tien Luong</p>
        <p>Benjamin Bician</p>
        <p>Helena Stindl</p>
        <p>Britta Reinwart</p>

        <!-- Content -->
        <h2 class="font-bold mt-6">Inhalt:</h2>
        <p>
          Diese Website dient zur Bereitstellung von Informationen über das Projekt "Linguexplorer", das im Rahmen einer Diplomarbeit an der HTL-Rennweg im Schuljahr 2024/25 entwickelt wurde. Linguexplorer ist eine Singleplayer-Webapplikation, die als Lernspiel konzipiert wurde und Schülerinnen und Schülern hilft, auf spielerische Weise die englische Sprache zu erlernen.
        </p>

        <!-- Address -->
        <h2 class="font-bold mt-6">Adresse:</h2>
        <p>Rennweg 89b, 1030 Wien</p>

        <!-- Contact -->
        <h2 class="font-bold mt-6">Kontaktdaten:</h2>
        <p class="underline">team@linguexplorer.com</p>

        <!-- Copyright -->
        <h2 class="font-bold mt-6">Urheberrecht:</h2>
        <p>
          Die Inhalte dieser Website sind urheberrechtlich geschützt. Jegliche Verwertung, die nicht vom Urheberrecht gedeckt ist, bedarf der schriftlichen Zustimmung des Betreibers.
        </p>

        <!-- Liability for Links -->
        <h2 class="font-bold mt-6">Haftung für Links:</h2>
        <p>
          Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich. Sollten Sie rechtswidrige Inhalte auf verlinkten Seiten bemerken, informieren Sie uns bitte, damit wir die Links umgehend entfernen können.
        </p>

        <!-- Soundeffekt Quellen -->
        <h2 class="font-bold mt-6">Soundeffekt-Quellen:</h2>
        <ul class="list-disc pl-5">
          <li>
            <b>Achievement:</b> arcade-ui-18-229517.mp3
            <br>
            Sound Effect by <a href="https://pixabay.com/de/users/floraphonic-38928062/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=229517" target="_blank">floraphonic</a> from <a href="https://pixabay.com/sound-effects//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=229517" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>Auswählen:</b> arcade-ui-1-229498
            <br>
            Sound Effect by <a href="https://pixabay.com/de/users/floraphonic-38928062/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=229517" target="_blank">floraphonic</a> from <a href="https://pixabay.com/sound-effects//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=229517" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>:</b>arcade-ui-6-229503
            <br>
            Sound Effect by <a href="https://pixabay.com/de/users/floraphonic-38928062/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=229517" target="_blank">floraphonic</a> from <a href="https://pixabay.com/sound-effects//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=229517" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>Benachrichtigung:</b> 
            <br>
            Sound Effect by <a href="https://pixabay.com/users/rasoolasaad-47313572/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=269288" target="_blank">Rasool Asaad</a> from <a href="https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=269288" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>Bumping:</b> Pixel-sound-effect-4-82881
            <br>
            Sound Effect by <a href="https://pixabay.com/users/freesound_community-46691455/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=82881" target="_blank">freesound_community</a> from <a href="https://pixabay.com/sound-effects//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=82881" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>:</b> pixel-sound-effect-5-103221
            <br>
            Sound Effect by <a href="https://pixabay.com/users/freesound_community-46691455/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=103221" target="_blank">freesound_community</a> from <a href="https://pixabay.com/sound-effects//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=103221" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>ButtonNichtVerfügbar:</b> 
            <br>
            Sound Effect by <a href="https://pixabay.com/users/rasoolasaad-47313572/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=269282" target="_blank">Rasool Asaad</a> from <a href="https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=269282" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>Dog:</b> 
            <br>
            Sound Effect by <a href="https://pixabay.com/de/users/u_5wgfa0ekjt-41084060/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=179915" target="_blank">u_5wgfa0ekjt</a> from <a href="https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=179915" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>Entwählen:</b> 
            <br>
            Sound Effect by <a href="https://pixabay.com/users/floraphonic-38928062/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=188105" target="_blank">floraphonic</a> from <a href="https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=188105" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>FalscheAntwort:</b> arcade-ui-4-229502
            <br>
            Sound Effect by <a href="https://pixabay.com/nl/users/floraphonic-38928062/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=229502" target="_blank">floraphonic</a> from <a href="https://pixabay.com/sound-effects//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=229502" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>:</b> arcade-ui-5-229504
            <br>
            Sound Effect by <a href="https://pixabay.com/fr/users/floraphonic-38928062/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=229504" target="_blank">floraphonic</a> from <a href="https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=229504" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>Katze:</b> cat-meow-8-fx-306184
            <br>
            Sound Effect by <a href="https://pixabay.com/ro/users/sound_garage-47313534/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=306184" target="_blank">SOUND_GARAGE</a> from <a href="https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=306184" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>PopUp:</b> tap-notification-180637
            <br>
            Sound Effect by <a href="https://pixabay.com/users/lucadialessandro-25927643/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=180637" target="_blank">Luca Di Alessandro</a> from <a href="https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=180637" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>Raketenabsturz:</b> 
            <br>
            Sound Effect by <a href="https://pixabay.com/de/users/freesound_community-46691455/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=89534" target="_blank">freesound_community</a> from <a href="https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=89534" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>richtigeAntwort:</b> 90s-game-ui-6-185099
            <br>
            Sound Effect by <a href="https://pixabay.com/users/floraphonic-38928062/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=185099" target="_blank">floraphonic</a> from <a href="https://pixabay.com/sound-effects//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=185099" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>SpeicherstandAuswählen:</b> 
            <br>
            Sound Effect by <a href="https://pixabay.com/users/notification_message-47259947/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=270130" target="_blank">Devrinta Rose Nataya</a> from <a href="https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=270130" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>startSound:</b> 
            <br>
            Sound Effect by <a href="https://pixabay.com/de/users/freesound_community-46691455/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=6104" target="_blank">freesound_community</a> from <a href="https://pixabay.com/sound-effects//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=6104" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>TestSound:</b> 
            <br>
            Sound Effect by <a href="https://pixabay.com/users/notification_message-47259947/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=270134" target="_blank">Devrinta Rose Nataya</a> from <a href="https://pixabay.com/sound-effects//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=270134" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>Umblättern:</b> page-flip-47177
            <br>
            Sound Effect by <a href="https://pixabay.com/users/freesound_community-46691455/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=47177" target="_blank">freesound_community</a> from <a href="https://pixabay.com/sound-effects//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=47177" target="_blank">Pixabay</a>
          </li>
          <li>
            <b>X_Knopf:</b> 
            <br>
            Sound Effect by <a href="https://pixabay.com/users/rasoolasaad-47313572/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=269289" target="_blank">Rasool Asaad</a> from <a href="https://pixabay.com/sound-effects//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=269289" target="_blank">Pixabay</a>
          </li>
           <li>
            <b>Sprechsound:</b> Alien-talking-312011
            <br>
            Sound Effect by <a href="https://pixabay.com/users/artificiallyinspired-30441549/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=312011" target="_blank">ArtificiallyInspired</a> from <a href="https://pixabay.com/sound-effects//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=312011" target="_blank">Pixabay</a>
          </li>
           <li>
            <b>:</b> Alien-high-pitch-312010
            <br>
            Sound Effect by <a href="https://pixabay.com/users/artificiallyinspired-30441549/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=312010" target="_blank">ArtificiallyInspired</a> from <a href="https://pixabay.com/sound-effects//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=312010" target="_blank">Pixabay</a>
          </li>
           <li>
            <b>:</b> Cute-alien
            <br>
            Sound Effect by <a href="https://pixabay.com/users/artificiallyinspired-30441549/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=291369" target="_blank">ArtificiallyInspired</a> from <a href="https://pixabay.com/sound-effects//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=291369" target="_blank">Pixabay</a>
          </li>
           <li>
            <b>Minispiel_Essen:</b> 
            <br>
            Music by <a href="https://pixabay.com/ru/users/backgroundmusicforvideo-46826676/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=263126" target="_blank">BackgroundMusicForVideo</a> from <a href="https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=263126" target="_blank">Pixabay</a>
          </li>
           <li>
            <b>Minispiel_Kleidung:</b> 
            <br>
            Music by <a href="https://pixabay.com/de/users/music_for_videos-26992513/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=156936" target="_blank">Anastasia Chubarova</a> from <a href="https://pixabay.com/music//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=156936" target="_blank">Pixabay</a>
          </li>
           <li>
            <b>Minispiel_Schule:</b> 
            <br>
            Music by <a href="https://pixabay.com/de/users/crab_audio-47493304/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=300579" target="_blank">EVGENY</a> from <a href="https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=300579" target="_blank">Pixabay</a>
          </li>
           <li>
            <b>Minispiel_Familie:</b> 
            <br>
            Music by <a href="https://pixabay.com/de/users/goldensoundlabs-31886162/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=222524" target="_blank">Golden Sound Labs</a> from <a href="https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=222524" target="_blank">Pixabay</a>
          </li>
           <li>
            <b>Hintergrundmusik:</b> 
            <br>
            Music by <a href="https://pixabay.com/de/users/monument_music-34040748/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=194622" target="_blank">Oleksii Holubiev</a> from <a href="https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=194622" target="_blank">Pixabay</a>
          </li>
        </ul>
      </div>
    </main>

    <!-- Footer -->
    <footer class="mt-auto">
      <section class="mx-auto p-4 flex justify-end items-center">
        <button class="lg:max-w-[200px] md:max-w-[150px] sm:max-w-[100px] max-w-[100px] hover:opacity-80 hover:scale-110 transform transition-transform duration-200 ease-in-out">
          <router-link to="/" href="#">
            <img src="@/assets/xx_Images/xx_Images/Buttons/button zrk.png" alt="Zurück" />
          </router-link>
        </button>
      </section>
    </footer>

  </div>
</template>

<script>
export default {
  name: 'ImpressumPage',
};
</script>

<style scoped>
/* Hover animation */
.hover-button img {
  transition: transform 0.2s ease-in-out;
}

.hover-button img:hover {
  transform: scale(1.05);
}
</style>